import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type AppDialogType = 'success' | 'error' | 'info' | 'warning';

export interface AppDialogData {
  type: AppDialogType;
  title: string;
  message: string;
  buttonText?: string;
}

@Component({
  selector: 'app-app-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './app-dialog.component.html',
  styleUrls: ['./app-dialog.component.scss'],
})
export class AppDialogComponent {
  constructor(
    private ref: MatDialogRef<AppDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppDialogData,
  ) {}

  close() {
    this.ref.close(true);
  }

  icon(): string {
    switch (this.data.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  }
}
